export default __webpack_public_path__ + "app/module/eficiencia-fiscal/view/configuracao/tabelas-sped/tabela-itens/importar-legislacao.html";